export const CUSTOM_SHADOW_MIN_DISTANCE = 0;
export const CUSTOM_SHADOW_MAX_DISTANCE = 100;
